import React from 'react'
import { cn } from '../lib/utils'

/**
 * Flat surface: Pure Surface background, no border, no shadow (No-Border Rule).
 * Reads as a card purely by sitting on the gradient page — see DESIGN.md Elevation.
 */
export function Card({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
    return <div {...props} className={cn('rounded-2xl bg-card p-4 text-card-foreground shadow-sm', className)} />
}

export function CardHeader({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
    return <div {...props} className={cn('mb-3 flex flex-wrap items-end justify-between gap-3', className)} />
}

export function CardTitle({ className, ...props }: React.ComponentPropsWithoutRef<'h3'>) {
    return <h3 {...props} className={cn('text-[1.0625rem] font-semibold text-card-foreground', className)} />
}

export function CardBody({ className, ...props }: React.ComponentPropsWithoutRef<'div'>) {
    return <div {...props} className={cn('text-sm text-muted-foreground', className)} />
}
